import { useQuery } from '@tanstack/react-query';
import { getChatbotSettings } from 'pages/admin/sqp/chatbot-settings/chatbot-settings.thunks';

export const useChatbotSettings = (currentPage: number, queryKey: string) => {
  const { data, isFetching } = useQuery({
    queryKey: [queryKey],
    queryFn: async () => await getChatbotSettings({ page: currentPage }),
    refetchOnWindowFocus: false,
    retry: false,
    cacheTime: 0,
  });

  return {
    isFetching,
    data,
  };
};
